import { ILanguage } from "../../interfaces/ILanguage";

export const en: ILanguage = {
  // General
  Add: "Add",
  Added: "Added",
  Included: "Included",
  NotAvailable: "Not available",
  Home: "Home",

  // Error handling
  RequiredField: "This field is required",
  PhoneNumberMustBe10Digits: "Phone number must be 10 digits (XXX XXX XX XX)",
  ZipNumberMustBe5Digits: "Zip code must be 5 digits (XXX XX)",

  // Order
  SubscriptionDetails: "Package details",
  OrganisationDetails: "Organization details",
  InvoiceDetails: "Invoice details",

  Subscription: "Package",
  NumberOfUsers: "Number of users",
  OrganisationNumber: "Organization number",
  OrganisationNumberPlaceholder: "55123456-7890",
  OrganisationName: "Organization name",
  OrganisationNamePlaceholder: "365Robust AB",
  OrganisationType: "Organization type",
  OrganisationTypePlaceholder: "Aktiebolag",
  NumberOfEmployees: "Number of employees",
  Snis: "SNI-codes",
  SnisPlaceholder: "62010, 62020, 43290...",
  NumberOfWorkplaces: "Number of workplaces",

  InvoiceName: "Invoice name",
  InvoiceNamePlaceholder: "365Robust AB",
  InvoiceAddress: "Invoice address",
  InvoiceAddressPlaceholder: "Virkesvägen 13a",
  InvoiceReference: "Invoice reference",
  InvoiceReferencePlaceholder: "R365-12345",
  PostalCode: "Postal code",
  PostalCodePlaceholder: "120 78",
  County: "County",
  CountyPlaceholder: "Stockholm",
  PhoneNumber: "Phone number",
  PhoneNumberPlaceholder: "070-123 45 67",
  Email: "Email",
  EmailPlaceholder: "info@365robust.se",
  OtherInvoiceDetails: "Other invoice details",
  OtherInvoiceDetailsPlaceholder: "",

  // Basket
  Basket: "Basket",
  Product: "Product",
  Quantity: "Quantity",
  MonthlyCost: "Monthly cost",
  TotalMonthlyCost: "Total monthly cost",
  StartingFee: "Starting fee",
  Addon: "Addon",
  Addons: "Addons",
  Users: "Users",
  Workplaces: "Workplaces",
  Other: "Other",
  OneTimeFee: "One-time fee",
  Information: "Information",
  Order: "Ordrer",

  // Order confirm
  ThankYouForYourOrder: "Thank you for your order",
  WeHaveReceivedYourOrder: "We have received your order",
  WeWillContactYouSoon:
    "We will contact you as soon as we have processed your order",

  CurrencyPerMonth: "SEK/month",
  CurrencyShortForm: "SEK",
  Next: "Next",
  Back: "Back",
  ConfirmOrder: "Confirm order",
  OrderDetails: "Order details",
  ContactInformation: "Contact information",

  // Packages
  OPTIMAL: "Optimal",
  STOR: "Stor",
  GRUNDLAGGANDE: "Grundläggande",
  MINIMAL: "Minimal",
  STARTUP: "Startup (utan anställda)",
  CUSTOM: "Custom",

  ChooseOneOfOurPackages:
    "Choose one of our popular packages, or contact us for a quote",
  WhichSubscriptionLevelShouldIChoose:
    "Which subscription level should I choose?",
  MostPopular: "Most popular!",
  Demands: "Demands",
  DemandModule: "Demand module",
  Process: "Process",
  ProcessPlural: "Processes",
  AllProcesses: "(all)",
  Workplace: "Workplace",
  WorkplacePlural: "Workplaces",
  ShowMorePackages: "Show more packages",
  HidePackages: "Hide packages",
  NoPackageSuitsYou: "None of the packages suit you?",
  ContactUsForQuote: "Contact us for a quote",

  // Order addons
  BaseModules: "Base modules",
  ComplianceAreas: "Processes",
  Modules: "Modules",
  ProcessesSelectedCount: "{{count}} selected · {{included}} included in package",
  ProcessesIncludedCount: "{{count}} of {{total}} included in your package",
  Processes: "Processes",
  RequiresBaseModule: "Requires base module: {{name}}",

  // Policy / legal
  PolicyAcceptance:
    "I accept that 365Robust AB stores my information and contacts me based on this",

  // Error page
  ErrorDefaultText: "Oops! Something went wrong",
  PageLoadError: "The page could not be loaded as expected",
  ErrorMessageLabel: "Error message:",
  GoToStart: "Go to start",
  PageNotFound: "This page does not exist",

  // Login
  WelcomeTitle: "Welcome to 365Robust.se",
  SignIn: "Sign in",

  // Contact details
  FillInYourContactDetails:
    "Fill in your contact details and we will get in touch with you to set up an account and sign the agreement.",
  FirstName: "First name",
  FirstNamePlaceholder: "John",
  LastName: "Last name",
  LastNamePlaceholder: "Doe",
  OtherInformation: "Other information",
};
